package music.jammers.web.domain.model

import music.jammers.client.shared.network.domain.model.ApiConfig

internal class WebApiConfig : ApiConfig {

    private val url = "https://test.thejammers.org/api/v1/"
    //    private val url = "http://localhost:8080/api/v1/"

    override fun getBaseUrl(): String = url
}